// @flow
import {CardText} from "material-ui/Card"
import {
  Table,
  TableHeader,
  TableHeaderColumn as TH,
  TableBody,
  TableRow as TR,
  TableRowColumn as TD,
} from "material-ui/Table"
import {Tabs, Tab} from "material-ui/Tabs"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {Link} from "react-router-dom"
import * as React from "react"
import * as Maybe from "flow-static-land/lib/Maybe"
import {containers} from "@swarm2/core"
import * as Util from "../common"

const M = Util.intlMessages("view.StatisticsView")
const UM = Util.intlMessages("units")

function ProductionStatisticsNumTD({val}) {
  return (
    <TD style={{textAlign: "right"}}>
      {val === undefined ? null : <Util.Num val={val} />}
    </TD>
  )
}
function ProductionStatisticsRowRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    unitName,
    bought,
    clicks,
    spent,
    looted,
    grown,
    firstElapsed,
    isVisible,
  } = props
  if (!isVisible) return null
  //console.log(unitName, {bought, clicks, spent, looted, grown, firstSince})
  return (
    <TR key={unitName}>
      <TD>
        <UM id={unitName + ".plural"} values={{count: 1}} />
      </TD>
      <TD style={{textAlign: "right"}}>
        {Maybe.maybe("-", ms => <Util.Duration millis={ms} />, firstElapsed)}
      </TD>
      <ProductionStatisticsNumTD val={bought} />
      <ProductionStatisticsNumTD val={clicks} />
      <ProductionStatisticsNumTD val={spent} />
      <ProductionStatisticsNumTD val={looted} />
      <ProductionStatisticsNumTD val={grown} />
    </TR>
  )
}
export const ProductionStatisticsRow = containers.statistics.ProductionStatisticsRow(
  ProductionStatisticsRowRender,
)

function ProductionStatistics(props) {
  const {unitNames, charId} = props
  return (
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TR>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.name" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.first" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.bought" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.clicks" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.spent" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.looted" />
          </TH>
          <TH style={{textAlign: "right"}}>
            <M id="production.col.grown" />
          </TH>
        </TR>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {unitNames.map(name => (
          <ProductionStatisticsRow key={name} unitName={name} charId={charId} />
        ))}
      </TableBody>
    </Table>
  )
}
function CombatStatistics(props) {
  return (
    <div>
      Coming soon.
      {/*<Table selectable={false}>
        <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
          <TR>
            <TH><M id="combat.col.name" /></TH>
            <TH style={{textAlign: "right"}}><M id="combat.col.first" /></TH>
            <TH style={{textAlign: "right"}}><M id="combat.col.produced" /></TH>
            <TH style={{textAlign: "right"}}><M id="combat.col.lost" /></TH>
            <TH style={{textAlign: "right"}}><M id="combat.col.killed" /></TH>
          </TR>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          <TR>
            <TD>Swarmling</TD>
            <TD style={{textAlign: "right"}}>3d 10h 12:15.123</TD>
            <TD style={{textAlign: "right"}}><Num val={99} /></TD>
            <TD style={{textAlign: "right"}}><Num val={11} /></TD>
            <TD style={{textAlign: "right"}}><Num val={0} /></TD>
          </TR>
          <TR>
            <TD>Roach</TD>
            <TD style={{textAlign: "right"}}>3d 10h 12:15.123</TD>
            <TD style={{textAlign: "right"}}><Num val={99} /></TD>
            <TD style={{textAlign: "right"}}><Num val={11} /></TD>
            <TD style={{textAlign: "right"}}><Num val={0} /></TD>
          </TR>
        </TableBody>
      </Table>*/}
    </div>
  )
}
function MiscStatisticsRender(props) {
  const {createdAt, totalClears, totalWins, totalFights} = props
  return (
    <div>
      <p>
        <M
          id="other.created"
          values={{val: <Util.FromNow since={createdAt} />}}
        />
      </p>
      <p>
        <M
          id="other.totalclears"
          values={{val: <Util.Num val={totalClears} />}}
        />
      </p>
      <p>
        <M id="other.totalwins" values={{val: <Util.Num val={totalWins} />}} />
      </p>
      <p>
        <M
          id="other.totalfights"
          values={{val: <Util.Num val={totalFights} />}}
        />
      </p>
    </div>
  )
}
export const MiscStatistics = containers.statistics.MiscStatistics(
  MiscStatisticsRender,
)

// "Table sorting?" - it's in the next material-ui release. Tried using it a
// while back (material-ui@next ; 2017 April-ish), but it's missing some other
// elements I needed. Give it more time.
// https://github.com/callemall/material-ui/issues/1352
export function StatisticsRender(props: Object) {
  if (props.isError) return <Util.Error error={props} />
  const {
    displayName,
    charId,
    unitNames,
    match: {params: {tabName}},
    readonly,
  } = props
  //console.log({displayName, createdAt, charId, unitNames, match, error})
  const url = (readonly ? "/c/" : "/p/") + charId + "/statistics"
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
        </ToolbarGroup>
      </Toolbar>
      <Tabs value={tabName}>
        <Tab
          label={<M id="production.title" />}
          value="production"
          containerElement={<Link to={url + "/production"} />}
        >
          <CardText>
            <ProductionStatistics unitNames={unitNames} charId={charId} />
          </CardText>
        </Tab>
        <Tab
          label={<M id="combat.title" />}
          value="combat"
          containerElement={<Link to={url + "/combat"} />}
        >
          <CardText>
            <CombatStatistics charId={charId} />
          </CardText>
        </Tab>
        <Tab
          label={<M id="other.title" />}
          value="other"
          containerElement={<Link to={url + "/other"} />}
        >
          <CardText>
            <MiscStatistics charId={charId} />
          </CardText>
        </Tab>
      </Tabs>
    </div>
  )
}
export const StatisticsView = containers.statistics.Statistics(
  Util.DumpProps(StatisticsRender),
)



// WEBPACK FOOTER //
// ./src/statistics/StatisticsView.js